export default __webpack_public_path__ + "static/media/falcon_logo.8377776f.svg";